import { FormCheckbox, FormInput, FormSelect } from 'components/common/form'
import User from 'singletons/User'
import { useFormContext, Controller } from 'react-hook-form'
import { ErrorMessage } from '@hookform/error-message'
import ErrorFieldForm from 'components/UI/ErrorFieldForm'
import formatMultiselectErrors from 'util/formatMultiselectErrors'
import InputMask from 'react-input-mask'
import { phoneTypesOptions } from 'constants/phoneTypes'
import { stateOptions } from 'constants/states'

const AccountGeneralFormContent = () => {
  const { provider } = User

  const { email } = provider

  const {
    register,
    control,
    formState: { errors: initErrors },
  } = useFormContext()

  const errors = formatMultiselectErrors(initErrors)

  return (
    <>
      <FormInput value={email} label={'Email*'} disabled className="mb-4" data-testid={'edit-email-input'} />
      <h6 className="mb-4 typography-body-xl font-semibold uppercase text-neutral-500">Physical address</h6>
      <div className="flex flex-col mb-6 mt-4">
        <FormInput
          autoComplete={'off'}
          label={'Street 1*'}
          {...register('street1')}
          data-testid={'edit-street1-input'}
        />
        <ErrorMessage errors={errors} name={'street1'} as={<ErrorFieldForm />} />
      </div>
      <div className="mb-6">
        <FormInput
          autoComplete={'off'}
          label={'Street 2'}
          {...register('street2')}
          data-testid={'edit-street2-input'}
        />
        <ErrorMessage errors={errors} name={'street2'} as={<ErrorFieldForm />} />
      </div>
      <div className="mb-6">
        <FormInput autoComplete={'off'} label={'City*'} {...register('city')} data-testid={'edit-city-input'} />
        <ErrorMessage errors={errors} name={'city'} as={<ErrorFieldForm />} />
      </div>
      <div className="mb-6 flex mt-4">
        <div className="flex flex-col flex-1 mr-5">
          <Controller
            name={'state'}
            control={control}
            render={({ field }) => (
              <FormSelect
                {...field}
                label={'State*'}
                options={stateOptions}
                disabled={!stateOptions.length}
                getOptionLabel={(s) => s.label}
                getOptionValue={(s) => s.value}
                className="mr-5"
                onChange={(e) => field.onChange(e.target.value)}
              />
            )}
          />
          <ErrorMessage errors={errors} name={'state'} as={<ErrorFieldForm />} />
        </div>
        <div className="flex flex-col flex-1">
          <FormInput autoComplete={'off'} label={'Zip code*'} {...register('zip')} />
          <ErrorMessage errors={errors} name={'zip'} as={<ErrorFieldForm />} />
        </div>
      </div>
      <h6 className="mb-4 typography-body-xl font-semibold uppercase text-neutral-500">Contact phone</h6>
      <div className="flex mt-4 mb-8">
        <div className="flex flex-col flex-1 mr-5">
          <Controller
            name={'phoneNumber'}
            control={control}
            defaultValue=""
            render={({ field: { onChange, value } }) => {
              return (
                <InputMask mask="(999) 999-9999" value={value} onChange={onChange}>
                  {(inputProps) => (
                    <FormInput autoComplete={'off'} label={'Phone number*'} className="mr-5" {...inputProps} />
                  )}
                </InputMask>
              )
            }}
          />
          <ErrorMessage errors={errors} name={'phoneNumber'} as={<ErrorFieldForm />} />
        </div>
        <div className="flex flex-col flex-1">
          <Controller
            name={'phoneType'}
            control={control}
            render={({ field }) => (
              <FormSelect
                {...field}
                label={'Phone type*'}
                options={phoneTypesOptions}
                disabled={!phoneTypesOptions.length}
                getOptionLabel={(s) => s.label}
                getOptionValue={(s) => s.value}
                onChange={(e) => field.onChange(e.target.value)}
              />
            )}
          />
          <ErrorMessage errors={errors} name={'phoneType'} as={<ErrorFieldForm />} />
        </div>
      </div>
      <div className="flex flex-col">
        <Controller
          name={'acceptSmsNotifications'}
          control={control}
          render={({ field }) => (
            <FormCheckbox {...field} checked={field.value} label={'Accept SMS Notifications'} className="mb-2" />
          )}
        />
        <ErrorMessage errors={errors} name={'acceptSmsNotifications'} as={<ErrorFieldForm />} />
        <Controller
          name={'acceptEmailNotifications'}
          control={control}
          render={({ field }) => <FormCheckbox {...field} checked={field.value} label={'Accept Email Notifications'} />}
        />
        <ErrorMessage errors={errors} name={'acceptEmailNotifications'} as={<ErrorFieldForm />} />
      </div>
    </>
  )
}

export default AccountGeneralFormContent
